export const HtmlBlockPendingPlaceholder = () => {
  return (
    <>
      <style>{`
        @keyframes html-block-pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        .html-block-pending-text {
          animation: html-block-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
      <div
        style={{
          margin: '12px 0',
          width: '100%',
          borderRadius: '12px',
          padding: '16px',
          border: '1px solid var(--ds-border-default, #d7dae4)',
          background: 'var(--ds-bg-subtle, #f1f2f7)',
        }}
      >
        <p
          className="html-block-pending-text"
          style={{
            fontSize: '14px',
            fontStyle: 'italic',
            color: 'var(--ds-fg-tertiary, #8c92a5)',
            margin: 0,
          }}
        >
          Rendering your HTML…
        </p>
      </div>
    </>
  )
}

export default HtmlBlockPendingPlaceholder
